<ng-container>
    <app-bloque-de-bienvenida [pageData]="pageData.bloqueDeBienvenida"></app-bloque-de-bienvenida>
    <app-bloque-quienes-somos [pageData]="pageData.bloqueQuienesSomos"></app-bloque-quienes-somos>

  <ng-container>
    <app-marco-legal [fields]="pageData.rights_section">
    </app-marco-legal>
  </ng-container>

</ng-container>
